import $ from 'jquery';
import 'bootstrap';

export default class Toaster {
  static toastHeader(options) {
    const header = $('<div class="toast-header"></div>');
    if (options.icon !== undefined) {
      header.append(`<img src="${options.icon}" class="rounded mr-2" />`);
    }
    if (options.title !== undefined) {
      header.append(`<strong class="mr-auto">${options.title}</strong>`);
    }
    if (options.time !== undefined) {
      header.append(`<small class="text-muted">${options.time}</small>`);
    }
    header.append(
      '<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
    );
    return header;
  }

  static toastBody(options) {
    const body = $('<div class="toast-body"></div>');
    body.append(options.content);
    return body;
  }

  static showToast(options, id) {
    const toastOptions = {};
    if (options.delay) {
      toastOptions.delay = options.delay;
    } else {
      toastOptions.autohide = false;
    }
    const toast = $(
      `<div id="${id || new Date().getTime()}" class="toast ${
        options.className
      }" role="alert" aria-live="assertive" data-test='toast-message' aria-atomic="true"></div>`
    );
    toast.append(this.toastHeader(options));
    toast.append(this.toastBody(options));
    $('#toast_container').append(toast);
    $(toast).toast(toastOptions);
    $(toast).toast('show');
  }
}
